// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"bb643e15","82":"04c0576e","343":"8cce6c73","373":"e1546425","461":"a13534d8","570":"95654543","854":"d26bda5d","940":"f6ad2324"}[chunkId] + ".css";
};